import React, { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { api } from "@/lib/api";
import TemplateClassic from "@/components/templates/TemplateClassic";
import TemplateModernDark from "@/components/templates/TemplateModernDark";
import TemplateVibrant from "@/components/templates/TemplateVibrant";
import TemplateMinimal from "@/components/templates/TemplateMinimal";
import TemplateEnterprise from "@/components/templates/TemplateEnterprise";

const TEMPLATES = {
  classic: TemplateClassic,
  modern_dark: TemplateModernDark,
  vibrant: TemplateVibrant,
  minimal: TemplateMinimal,
  enterprise: TemplateEnterprise,
};

export default function SitePreview() {
  const { subdomain } = useParams();
  const site = useOutletContext();



  if (!site) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-400 text-sm">Loading site…</div>
    </div>
  );

  const Template = TEMPLATES[site.template_id] || TemplateClassic;
  return <Template site={site} />;
}
